'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import StoredContentContainer from '../../containers/StoredContentContainer';
import { LearningContentContainer } from '../../features/learningContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TrackExamPage = ({
  track,
  onAdvanceContent,
  contentId
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(LearningContentContainer, {
      contentId: contentId,
      language: track.get('language'),
      trackId: track.get('id'),
      children: /*#__PURE__*/_jsx(StoredContentContainer, {
        contentId: contentId,
        isParentGraded: true,
        language: track.get('language'),
        onFinish: onAdvanceContent,
        trackId: track.get('id'),
        trackName: track.get('name')
      })
    })
  });
};
TrackExamPage.propTypes = {
  contentId: PropTypes.string.isRequired,
  onAdvanceContent: PropTypes.func.isRequired,
  track: ImmutablePropTypes.map.isRequired
};
export default TrackExamPage;